import React from 'react';
import Heading from '@react/react-spectrum/Heading';
import { TabView, Tab } from '@react/react-spectrum/TabView';

import CreateDistributorPage from './components/CreateDistributorPage/CreateDistributorPage';
import GrantAccessPage from './components/GrantAccessPage/GrantAccessPage';
import QuickCreateDistributorPage from './components/QuickCreateDistributorPage/QuickCreateDistributorPage';
import ManageBannerPage from './components/ManageBannerPage/ManageBannerPage';
import { checkBannerAdminAccess } from '../providers/BannerAdminAPI';

interface InternalTab {
  label: string;
  renderContent: () => React.ReactElement;
}

const BASE_INTERNAL_TABS: InternalTab[] = [
  { label: 'Quick Create Distributor', renderContent: () => <QuickCreateDistributorPage /> },
  { label: 'Advanced Create Distributor', renderContent: () => <CreateDistributorPage /> },
  { label: 'Grant Portal Access', renderContent: () => <GrantAccessPage /> },
];
const MANAGE_BANNER_TAB: InternalTab = {
  label: 'Manage Banner',
  renderContent: () => <ManageBannerPage />,
};

function InternalPage(): React.ReactElement {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [canManageBanner, setCanManageBanner] = React.useState(false);

  React.useEffect(() => {
    checkBannerAdminAccess().then(setCanManageBanner);
  }, []);

  const internalTabs = canManageBanner ? [...BASE_INTERNAL_TABS, MANAGE_BANNER_TAB] : BASE_INTERNAL_TABS;

  const handleTabChange = (newSelectedTabIndex: number) => {
    setSelectedIndex(newSelectedTabIndex);
  };

  return (
    <div>
      <Heading variant='pageTitle'>Adobe Internal Console</Heading>
      <TabView selectedIndex={selectedIndex} onSelect={handleTabChange}>
        { internalTabs.map((tab) => (
            <Tab key={tab.label} label={tab.label} />
          ))
        }
      </TabView>
      {internalTabs[selectedIndex]?.renderContent()}
    </div>
  );
}

export default InternalPage;
